Ext.define('SA.view.SearchFieldInertMaskController', {
    statics: {
        create({field}) {
            var getInteractiveEls = () => [field.el.dom, field.locationsList.el.dom],
                inertMask = new SA.view.InertMask({getInteractiveEls}),
                controller = new SA.view.SearchFieldInertMaskController({inertMask});

            field.on('results:show', () => controller.onResultsShow());
            field.on('results:hide', () => controller.onResultsHide());

            controller.tabListener = SA.view.DomListenerBuilder.keydown('Tab').cb(() => controller.onTab());
            controller.mousemoveListener = SA.view.DomListenerBuilder.mousemove().cb(() => controller.onMouseMove());

            return controller;
        }
    },

    constructor({inertMask}) {
        this.inertMask = inertMask;
    },

    onMouseMove() {
        this.tabListener.listen();
        this.mousemoveListener.unlisten();

        this.inertMask.clear();
    },

    onResultsHide() {
        SA.view.ExtFloatingKeyDownHandlingToggle.enable();

        this.tabListener.unlisten();
        this.mousemoveListener.unlisten();

        this.inertMask.clear();
    },

    onResultsShow() {
        SA.view.ExtFloatingKeyDownHandlingToggle.disable();

        this.tabListener.listen();
    },

    onTab() {
        this.tabListener.unlisten();
        this.mousemoveListener.listen();

        this.inertMask.apply();
    }
});